import { getForceSignInUrl, getMsaImplicitGrantSignInUrl } from '../shared/auth/getSignInUrl'

export const redirectToAuth = (isMsaAccount: boolean) => {
  // Redirect the user to login flow
  window.location.href = isMsaAccount ? getMsaImplicitGrantSignInUrl() : getForceSignInUrl(false)

  return {
    shouldStopExecution: true,
    userInfo: undefined,
  }
}
